/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { injectIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import { change, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import CardBook from './CoursePlanCardBook';

const RightSide = (props) => {
  const { data } = props;
  const {
    handleToggleAll,
    numberOfChecked,
    handleToggle,
    setRight,
    setSuggested,
    checked,
    optionLabel,
    suggested,
    right,
    classes,
  } = data;

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const sourceIdx = parseInt(result.source.index, 10);
    const destIdx = parseInt(result.destination.index, 10);
    const draggedLink = right[sourceIdx];
    const newList = right.slice();
    newList.splice(sourceIdx, 1);
    newList.splice(destIdx, 0, draggedLink);
    const finRes = [];
    for (const elem in newList) {
      finRes.push({
        resourceId: newList[elem],
        suggested: suggested[newList[elem]] !== undefined ? suggested[newList[elem]] : false,
      });
    }
    props.dispatch(change(`${props.form}`, 'resources', finRes));
    setRight(newList);
  };

  const changeSuggested = (res) => {
    const newSuggest = { ...suggested };
    newSuggest[res.id] = res.value;
    setSuggested(newSuggest);
    const finRes = [];
    for (const elem in right) {
      finRes.push({
        resourceId: right[elem],
        suggested: newSuggest[right[elem]] !== undefined ? newSuggest[right[elem]] : false,
      });
    }
    props.dispatch(change(`${props.form}`, 'resources', finRes));
  };

  if (right) {
    return (
      <Card>
        <CardHeader
          className={classes.cardHeader}
          avatar={(
            <Checkbox
              onClick={handleToggleAll(right)}
              checked={numberOfChecked(right) === right.length && right.length !== 0}
              indeterminate={numberOfChecked(right) !== right.length
                && numberOfChecked(right) !== 0}
              disabled={right.length === 0}
              inputProps={{ 'aria-label': 'all right selected' }}
            />
          )}
          title="Ressources choisies"
          subheader={`${numberOfChecked(right)}/${right.length} selected`}
        />
        <Divider />
        <DragDropContext onDragEnd={onDragEnd}>
          <CardBook
            suggested={suggested}
            setSuggested={changeSuggested}
            checked={checked}
            optionLabel={optionLabel}
            handleToggle={handleToggle}
            toDo={right}
          />
        </DragDropContext>
      </Card>
    );
  }
  return (<div />);
};

RightSide.propTypes = {
  data: PropTypes.any.isRequired,
  form: PropTypes.any.isRequired,
  dispatch: PropTypes.any.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return { initialValues: state.group.selectedGroup, form: name, dataform };
}

const connectedRightSide = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(injectIntl(RightSide));

const NewconnectedRightSide = connect(mapStateToProps, {})(connectedRightSide);

export default NewconnectedRightSide;
